<template lang="pug">
  .review-list
    review-list-item(
      v-for="review in reviews"
      :ref="review.id"
      :key="review.id"
      :review="review")
</template>

<style lang="scss" scoped>
.review-list {
  padding: 0px;

  .review-list-item {
    border-bottom: 1px solid rgba(255, 255, 255, 0.4);
  }
  .review-list-item:last-child {
    border: none;
  }
}
</style>

<script>
import ReviewListItem from '@/components/molecules/ReviewListItem'

export default {
  components: {
    ReviewListItem,
  },
  props: {
    reviews: {
      type: Array,
      required: true,
    },
  },
  methods: {
    reviewPositionBy(reviewId) {
      return this.$refs[reviewId][0].$el.offsetTop
    },
  },
}
</script>
